export default "__VITE_ASSET__DgUyY3N$__"